import { Component, OnInit, ViewChild, ViewContainerRef, NgModule, Compiler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WaitModalComponent } from '../wait-modal/wait-modal.component';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';
import { PopoverModule } from 'ngx-bootstrap/popover';

import { AppComponent } from '../../app.component';
import { ConsentOidcMainComponent } from './consent-oidc-main.component';
import { DisplayService } from '../../service/display.service';
import { AuthService } from '../../service/auth.service';
import { CustomViewService } from '../../service/custom-view.service';
import { environment } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';

declare let gtag: any; // グローバル変数gtagを解決

@Component({
  selector: 'app-consent-oidc',
  templateUrl: './consent-oidc.component.html',
  providers: [DisplayService, CustomViewService]
})
export class ConsentOidcComponent implements OnInit {

  // 画面ID
  readonly SCREEN_ID = 'O08';

  /** 認可を求めているクライアント名 */
  clientName: string;

  /** 認可を求めているクライアントURL */
  clientLogoUri: string;

  /** 認可が求められているOIDCスコープ説明の配列 */
  oidcScopes: string[];

  /** リソース表示名 */
  displayResourceName: string;

  /** リソース表示名(複数) */
  displayResourceNames: string[];

  // ページ番号定義
  public pageNo: number;

  // 操作クラス定義
  public comp: ConsentOidcMainComponent;

  // テンプレートファイ名（HTML）
  public templateHtml: string;

  // テンプレートファイル（CSS）
  public templateCss: string;

  // 画面資材ルートURL
  public assetsBaseUrl: string;

  // 共通画面資材URL
  public assetsPortalBaseUrl: string;

  // サービス名
  public serviceName: string;

  @ViewChild('waitModal', { static: false }) waitModal: WaitModalComponent;
  @ViewChild('confirmModal', { static: false }) confirmModal: ConfirmModalComponent;
  @ViewChild('dest', { read: ViewContainerRef, static: false })
  public dest: ViewContainerRef;

  constructor(
    private displayService: DisplayService,
    private authService: AuthService,
    private appComponent: AppComponent,
    private customViewService: CustomViewService,
    private compiler: Compiler,
    public translateService: TranslateService) { }

  /**
   * 初期処理
   */
  async ngOnInit() {
    this.pageNo = 1;

    if (this.appComponent.dispZ0000 === undefined) {
      await this.appComponent.getDisplayInfo();
    }

    // 読み込まれるHTML名の取得
    this.serviceName = '';
    if (this.appComponent.dispZ0000 === '') {
      this.serviceName = 'portal';
    } else {
      this.serviceName = this.appComponent.dispZ0000;
    }

    this.assetsBaseUrl = environment.storageBaseUrl + '/' + this.serviceName + '/adume';
    this.assetsPortalBaseUrl = environment.storageBaseUrl + '/portal';
    this.templateHtml = this.assetsBaseUrl + '/html/consent-oidc/' + this.serviceName + '_consent-oidc';
    this.templateCss = this.assetsBaseUrl + '/css/' + this.serviceName + '_consent-oidc.css';

    // 画面カスタマイズ情報
    await this.displayService.execAuthDisplayInfo(this.SCREEN_ID).subscribe(data => {
      this.clientName = data.clientName;
      this.clientLogoUri = data.clientLogoUri;
      this.oidcScopes = data.oidcScopes;
      this.displayResourceName = data.displayResourceName;
      if (this.displayResourceName !== undefined && this.displayResourceName !== null) {
        this.displayResourceNames = this.displayResourceName.split(',');
      }

      // カスタムページ表示
      this.directInjection();
    });
  }

  /**
  * コンポーネントを生成し親コンポーネントに挿入する
  *
  */
  public async directInjection() {

    gtag('config', environment.analyticsId, {
      'page_path': '/html/consent-oidc/' + this.serviceName + '_consent-oidc' + '/' + this.pageNo,
      'page_title': 'consent-oidc',
    });

    gtag('config', environment.analyticsIdGa4, {
      'page_title': 'consent-oidc',
      'page_location': this.serviceName + '/consent-oidc/' + this.pageNo
    });

    // 元の要素をクリアする
    this.dest.clear();

    // テンプレートを取得
    let templateHtmlText = await this.customViewService.getText(this.templateHtml + '_' + this.pageNo + '.html').toPromise();
    let templateCssText = await this.customViewService.getText(this.templateCss).toPromise();
    templateCssText = templateCssText.replace(/{{assetsBaseUrl}}/g, this.assetsBaseUrl);
    templateHtmlText = templateHtmlText.replace(/{{assetsBaseUrl}}/g, this.assetsBaseUrl);
    templateHtmlText = templateHtmlText.replace(/{{assetsPortalBaseUrl}}/g, this.assetsPortalBaseUrl);


    // Angular コンポーネントを用意する
    @Component({
      selector: 'app-consent-oidc-main',
      template: templateHtmlText,
      styles: [templateCssText],
    })

    class ConsentOidcModuleComponent extends ConsentOidcMainComponent { }
    // Angular モジュールを用意する

    @NgModule({
      imports: [CommonModule, FormsModule, PopoverModule.forRoot()],
      declarations: [ConsentOidcModuleComponent],
      exports: [ConsentOidcModuleComponent]
    })
    class ConsentOidcModule {
    }

    // Angular モジュールとコンポーネントをコンパイルする
    const module = this.compiler.compileModuleAndAllComponentsSync(ConsentOidcModule);
    // Angular モジュールから ConsentOidcModuleComponent を生成するファクトリを取り出す
    const factory = module.componentFactories.find((c) => {
      return c.componentType === ConsentOidcModuleComponent;
    });

    // ConsentOidcModuleComponent を生成し this.dest に設定する
    const componentRef = this.dest.createComponent(factory);

    // componentのインスタンスを取得する。
    this.comp = (<ConsentOidcModuleComponent>componentRef.instance);
    this.comp.init(this, this.authService, this.waitModal, this.confirmModal);
  }
}
